module.exports = __webpack_public_path__ + "static/media/address~eNQAoOWu.41e24872.svg";